import React, {useEffect, useState, useCallback, useReducer} from "react";
import {useLocation} from 'react-router';
import { Routes, Route } from "react-router";

// Routes:
import About     from "../../routes/About/About";
import Contact   from "../../routes/Contact/Contact";
import Favorites from "../../routes/Favorites/Favorites";
// import NewItem   from "../../routes/NewItem/NewItem";
import NewItem2  from "../../routes/NewItem/NewItem2";
import Home      from "../../routes/Home/Home";
// import Login     from "../../routes/Login/Login";


// UI Components:
// import CustomDialog from "../UI Components/Dialogs/CustomDialog";
// import CustomDrawer from "../UI Components/Drawers/CustomDrawer";

// MUI Components:
import Box from '@mui/material/Box';


function PageContent({onObjDetailPress}) { //favoriteList,onFavoritePress,onFavDeletePress

    const [currObj, setCurrObj ] = useState(null);
    // const [showObject, setShowObject] = useState(false);
    // const [drawerOpen, setDrawerOpen] = useState(false);

    const oDiaogSttng = {bDialogOpen:true, sDialogParam:'usrLgn', bFullScreen:true};


    // Drawer Object Detail
    // const handleObjectDetailPress  = (event) => { setDrawerOpen(true); }
    // const handleDrawerOpen = (event) => { setDrawerOpen(true); }
    const updateCurrObject = (id) => {
         setCurrObj(id); 
        };


    return(
        
        <Box sx={{backgroundColor:'#f4f4f4'}}>
            <Routes>
                {/* <Route path='login' element={<CustomDialog dialogSttng={oDiaogSttng}></CustomDialog>}></Route> */}
                <Route  index element={<Home onObjDetailPress={onObjDetailPress} updateCurrObject={updateCurrObject}/>}></Route>
                <Route path='favorites' element={<Favorites onObjDetailPress={onObjDetailPress}/>}></Route>
                {/* <Route path='newItem'   element={<NewItem/>}></Route> */}
                <Route path='newItem'   element={<NewItem2/>}></Route> 
                <Route path='about'     element={<About/>}></Route>
                <Route path='contact'   element={<Contact/>}></Route>   
            </Routes>


            {/* <CustomDialog oDialogProps={oDiaogProps}></CustomDialog> */}
        </Box>
    )
}

export default PageContent;